import React from 'react'

import AdmDashBoardFee from '../../components/AdminTabs/AdminFeeDashBoard/AdmDashBoardFee'

const FeeDashBoard = () => {
  return (
    <div>
        <AdmDashBoardFee />
    </div>
  )
}

export default FeeDashBoard